import { setToken, removeToken, setArea, removeArea } from "@/utils/auth";
import { Login, LogOut, ResetPwd, LoadArea } from "@/api/user";
import axios from "axios";
const state = () => ({
  user: {},
  area: [],
  setIsShowQuestionnaire: false,
  autoLogin: false,
  loging: false,
  webSite: "",
});
function getWebSet() {
  let baseUrl = location.host;
  let webSite = {
    logo: "https://file.jycyfww.com/followUpService/prod/static/img/4ef2d7bc5450490e9f91971f50ff52a4.png",
  };
  if (baseUrl.indexOf("yunnan") > -1) {
    webSite = {
      logo: "https://file.jycyfww.com/wangchuang/qc/prod/static/img/05ea45099963442ebe01556e1f4448f9.png",
    };
  } else if (baseUrl.indexOf("hubei") > -1) {
    webSite = {
      logo: "https://file.jycyfww.com/wangchuang/qc/test/img/store/7fce839bcce9427c87a1427a110b8f65.png",
    };
  } else if (baseUrl.indexOf("guangdong") > -1) {
    webSite = {
      logo: "https://file.jycyfww.com/wangchuang/qc/prod/static/img/54b645dcb63643cd97197dbce7052368.png",
    };
  } else if (baseUrl.indexOf("chongqing") > -1) {
    webSite = {
      logo: "https://file.jycyfww.com/wangchuang/qc/prod/static/img/0169dd1817904973a545c908235efa0b.png",
    };
  } else if (baseUrl.indexOf("fujian") > -1) {
    webSite = {
      logo: "https://file.jycyfww.com/wangchuang/qc/prod/static/img/7a5469075d564efebbd7d7e4a9f5485d.png",
    };
  } else if (baseUrl.indexOf("guizhou") > -1) {
    webSite = {
      logo: "https://file.jycyfww.com/wangchuang/qc/prod/static/img/8fad37488e774d20930f457c648fe752.png",
    };
  }

  return webSite;
}
const getters = {};
const actions = {
  SetWevSite({ commit }) {
    commit("setWevSite", getWebSet());
  },
  // 登录
  Login({ commit }, userinfo) {
    return new Promise((resolve, reject) => {
      Login(userinfo)
        .then((res) => {
          commit("SET_USER", res.loginUser);
          commit("set_loging", true);
          setToken(res.token);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  wLogin({ commit }, userinfo) {
    return new Promise((resolve, reject) => {
      axios
        .post(userinfo.url, userinfo)
        .then(({ data }) => {
          console.log(data);
          let res = data.data;
          commit("SET_USER", res.loginUser);
          commit("set_loging", true);
          setToken(res.token);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 退出登录
  LogOut({ commit }) {
    return new Promise((resolve) => {
      LogOut().then(() => {
        commit("RESET_USER", {});
        removeToken();
        commit("setIsShowQuestionnaire", false);
        resolve();
      });
    });
  },
  // 重置密码
  ResetPwd({ commit }, params) {
    return new Promise((resolve) => {
      ResetPwd(params).then(() => {
        commit("RESET_USER", {});
        resolve();
      });
    });
  },
  // 地区
  LoadArea({ commit }, params) {
    return new Promise((resolve) => {
      LoadArea(params).then((res) => {
        commit("SET_AREA", res);
        setArea(res);
        resolve();
      });
    });
  },
};
const mutations = {
  setWevSite(state, data) {
    state.webSite = data;
  },
  setAutoLogin(state, data) {
    state.autoLogin = data;
  },
  setIsShowQuestionnaire(state, data) {
    state.setIsShowQuestionnaire = data;
  },
  set_loging(state, data) {
    state.loging = data;
  },
  SET_USER(state, data) {
    state.user = data;
  },
  RESET_USER(state) {
    state.user = {};
    state.loging = false;
    state.setIsShowQuestionnaire = false;
    removeToken();
    removeArea();
  },
  SET_AREA(state, data) {
    state.area = data;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
